import React from 'react';

import { box, title, button } from './styles.module.scss';

const DownloadSlides = ({ data }) => {
  return (
    <div className={box}>
      <p className={title}>{data?.webinarOnDemandCtaBlockTitle}</p>

      <a
        href={data?.webinarOnDemandCtaSlidesFile?.mediaItemUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={button}
        id="link_webinar_on_demand_slides"
      >
        {data?.webinarOnDemandCtaButtonTitle}
      </a>
    </div>
  );
};

export default DownloadSlides;
